import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { popupManager } from './popup-manager';

export const PopupContext = React.createContext();

export const PopupContextProvider = (props) => {
  if (props.isGateEnabled) {
    popupManager.setGate();
  }

  if (props.timeout) {
    popupManager.setTimer(props.timeout);
  }

  if (props.permissions) {
    popupManager.setPermissions(props.permissions);
  }

  if (props.logger) {
    popupManager.setLogger(props.logger);
  }

  return (
    <PopupContext.Provider value={popupManager}>
      {props.children}
    </PopupContext.Provider>
  );
};

PopupContextProvider.propTypes = {
  isGateEnabled: PropTypes.bool,
  timeout: PropTypes.number,
  permissions: PropTypes.shape({}),
  logger: PropTypes.shape({}),
  children: PropTypes.element.isRequired,
};

PopupContextProvider.defaultProps = {
  isGateEnabled: false,
  timeout: null,
  permissions: {},
  logger: null,
};

export function withPopupProvider(Component) {
  class PopupProvider extends React.PureComponent {
    render() {
      if (this.props.isGateEnabled) {
        popupManager.setGate();
      }

      if (this.props.timeout) {
        popupManager.setTimer(this.props.timeout);
      }

      if (this.props.permissions) {
        popupManager.setPermissions(this.props.permissions);
      }

      if (this.props.logger) {
        popupManager.setLogger(this.props.logger);
      }

      return (
        <PopupContext.Provider value={popupManager}>
          <Component {...this.props} />
        </PopupContext.Provider>
      );
    }
  }

  PopupProvider.propTypes = {
    isGateEnabled: PropTypes.bool,
    timeout: PropTypes.number,
    permissions: PropTypes.shape({}),
    logger: PropTypes.shape({}),
  };

  PopupProvider.defaultProps = {
    isGateEnabled: false,
    timeout: null,
    permissions: {},
    logger: null,
  };

  return PopupProvider;
}

export const withPopupContext = WrappedComponent => (
  props => (
    <PopupContext.Consumer>
      {(val =>
        (<WrappedComponent
          {...props}
          popupManager={val}
        />))}
    </PopupContext.Consumer>
  )
);

export const usePopupContext = () => useContext(PopupContext);
